var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-secondary-13 p-3 rounded" },
    [
      _c("icon-view", {
        staticClass: "icon-view__extended",
        attrs: {
          icon: "fas fa-flag",
          "icon-background": "#fff",
          "icon-color": "#FF7058",
          "icon-size": "12px",
          title: "Información de la Determinación"
        }
      }),
      _c(
        "div",
        { staticClass: "ml-5" },
        [
          _c(
            "validation-observer",
            {
              ref: "determinationFormRef",
              attrs: { novalidate: "", tag: "form" }
            },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-text-area", {
                          attrs: {
                            "count-classes": ["d-block", "small-counter"],
                            "custom-error-msg": "El comentario es requerido.",
                            error: errors[0],
                            label: "Comentario:",
                            maxlength: 3000,
                            "show-char-count": ""
                          },
                          model: {
                            value: _vm.model.comment,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "comment", $$v)
                            },
                            expression: "model.comment"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end align-items-center" },
        [
          _c("action-button", {
            attrs: {
              i: "fas fa-times-circle",
              text: "Cancelar",
              variant: "outline-danger mr-3 px-3"
            },
            on: { click: _vm.onCancelHandler }
          }),
          _c("action-button", {
            attrs: {
              i: "fas fa-save",
              text: "Guardar",
              variant: "success px-3"
            },
            on: { click: _vm.onSaveHandler }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }